module.exports = __webpack_public_path__ + "img/plus-in-circles.12375444.svg";